import styled, { css } from "styled-components";
import * as Flex from "../../../../../../../../common-deprecated/styles/v2/toyota/globals/Flex";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import { getBreakpoint } from "../../../../../../../../common-deprecated/themes/common";

export const Wrapper = styled(Flex.Row)``;

export const SpinImages = styled.div`
    display: flex;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    flex-direction: row;
    height: 100%;
    transition:
        opacity 0.3s,
        transform 0.5s;
    overflow: hidden;
    z-index: 1;
`;

export const SpinInterior = styled.div<{ hasOutsideBox?: boolean }>`
    position: relative;
    flex: 1;
    width: 100%;
    padding-top: 47.43%;
    overflow: hidden;

    ${({ hasOutsideBox }) =>
        hasOutsideBox &&
        css`
            ${SpinImages} {
                left: -${theme.space[4]}px;
                right: -${theme.space[4]}px;
            }
        `};
`;

export const SpinGallery = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
`;

export const SpinImage = styled.img<{
    opacity?: number;
    margin?: string | number;
}>`
    width: 100%;
    max-width: 100%;
    height: auto;
    pointer-events: none;
    user-select: none;
    transition:
        opacity 0.3s,
        margin-left 0.3s;
    z-index: 5;
    ${({ margin }) =>
        margin &&
        margin !== "" &&
        css`
            margin-left: ${margin};
        `};
    ${({ opacity }) =>
        opacity &&
        css`
            opacity: ${opacity};
        `};
`;

export const SpinNavButtons = styled.div`
    display: none;
    position: absolute;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    z-index: 1001;

    button:nth-child(1) {
        margin-left: ${theme.space[3]}px;
        margin-right: auto;
    }

    button:nth-child(2) {
        margin-left: auto;
        margin-right: ${theme.space[3]}px;
    }

    @media ${getBreakpoint("up", "md")} {
        display: flex;
        bottom: ${theme.space[5]}px;
    }

    @media ${getBreakpoint("up", "lg")} {
        top: 50%;
        bottom: auto;
        transform: translateY(-50%);
    }

    html[dir="rtl"] & {
        button:nth-child(1) {
            margin-left: auto;
            margin-right: ${theme.space[3]}px;
        }
        button:nth-child(2) {
            margin-left: ${theme.space[3]}px;
            margin-right: auto;
        }
    }
`;

export const SpinNav = styled.nav`
    display: flex;
    position: absolute;
    bottom: ${theme.space[2]}px;
    left: 0;
    right: 0;
    align-items: center;
    justify-content: center;
    height: 32px;
    text-align: center;
    z-index: 1000;

    @media ${getBreakpoint("up", "lg")} {
        bottom: ${theme.space[5]}px;
    }
`;

export const SpinNavItem = styled.a<{ isActive?: boolean }>`
    display: inline-block;
    position: relative;
    width: 8px;
    height: 8px;
    margin-right: ${theme.space[2]}px;
    text-decoration: none;
    color: ${theme.colors.primaryBlack};
    background-color: ${({ isActive }) => (isActive ? theme.colors.primaryWhite : theme.colors.primaryBlack)};
    border-radius: 50%;
    outline: 0;
    cursor: pointer;
    opacity: ${({ isActive }) => (isActive ? 1 : 0.7)};
`;
